'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a title for the top menu
 *
 * @class
 */

class TopNavAvatar extends Core {

    _defaults() {
        return {
            target: '.js-menu-avatar',
            fields: {
                'avatar_url': '',
                'profile_url': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='float'>
                <a href='<%= profile_url %>' class='js-editor__topnav--avatar' title='My Profile'>
                    <div class='editor__topnav__avatar'>
                        <img src='<%= avatar_url %>'>
                    </div>
                </a>
            </div>
        `;

        super.render();

        /**
         * Click event
         *
         * @fires TopNavAvatar#_clicked
         */

         $('.js-editor__topnav--avatar', this.$el).on('click', this._clicked);
    }

    /**
     * @event TopNavAvatar#Cioui:TopNavAvatar:clicked
     * @property {String}Cioui:TopNavAvatar:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:TopNavAvatar:clicked', e);
    }


}
module.exports = TopNavAvatar;